import { Flex, Text } from '@chakra-ui/react';
import { HSeparator } from '../Separator/Separator';

const Logo = () => (
  <Flex mb="12px" direction="column" my="26px">
    <Text fontWeight="bold" textAlign="center" fontSize="xl">
      Submize
    </Text>
    <HSeparator mt="26px" />
  </Flex>
);

export default Logo;
